import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { UserAuthorizationService } from '../../../security/services/user-authorization.service';

@Component({
    selector: 'app-default-header',
    templateUrl: './default-header.component.html',
    styleUrls: ['./default-header.component.scss'],
})
export class DefaultHeaderComponent implements OnInit, OnDestroy {
    greetingTextKey!: string;

    isDevEnvironment = environment.production == false && environment.staging == false;
    isTestEnvironment = environment.staging == true;
    isProdEnvironment = environment.production == true;

    private greetingSubscription?: Subscription;

    constructor(
        private router: Router,
        protected authService: UserAuthorizationService
    ) { }



    ngOnInit(): void {
        this.setGreetingTextKey();
        this.startGreetingTimer();
    }


    ngOnDestroy(): void {
        this.greetingSubscription?.unsubscribe();
    }

    protected navigateToImpersonation() {
        if (this.authService.user?.isAdmin()) {
            this.router.navigate(['/admin/impersonation']);
        }
    }

    private setGreetingTextKey(): void {
        this.greetingTextKey = this.getGreetingTextKey();
    }

    private getGreetingTextKey(): string {
        const now = new Date();

        const morningMinutes = 11 * 60; // 11:00
        const eveningMinutes = 17 * 60; // 17:00

        var currentMinutes = now.getHours() * 60 + now.getMinutes();

        if (currentMinutes < morningMinutes) return 'main.header.greetingMorning';
        if (currentMinutes >= eveningMinutes) return 'main.header.greetingEvening';
        return 'main.header.greetingDay'
    }

    private startGreetingTimer(): void {
        const now = new Date();
        const msTillNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

        this.greetingSubscription = timer(msTillNextMinute, 60000).subscribe(() => {
            this.setGreetingTextKey();
        });
    }
}
